// ─── Bulk Run (execution-panel) ───────────────────────────────────────────────

/**
 * Live state of a server-side bulk run, keyed by campaignId. Counters mirror the
 * backend run snapshot — the client no longer tracks per-analysis items, so the
 * model scales to runs of any size.
 */
export interface BulkJobState {
  runId: string;
  organizationId: string;
  campaignId: string;
  phase: 'running' | 'done' | 'failed';
  total: number;
  dispatched: number;
  succeeded: number;
  failed: number;
  skipped: number;
  startedAt: string;
  completed?: number;
  pipelineFailed?: number;
  processing?: number;
  queued?: number;
  analysisUpdates?: Array<{
    id: string;
    technicalState: string;
    technicalTask: number;
    technicalStage: string;
  }>;
  notifId: string;
}

export interface PersistedBulkJob {
  runId: string;
  organizationId: string;
  campaignId: string;
  orgSlug: string | null;
  startedAt: string;
}

// ─── Watched Analysis (analysis-detail pipeline) ──────────────────────────────

export interface WatchedAnalysis {
  analysisId: string;
  organizationId: string;
  orgSlug: string | null;
  notifId: string;
  startedAt: string;
  startTask?: number;
  endTask?: number;
}

export interface PersistedWatchedAnalysis {
  analysisId: string;
  organizationId: string;
  orgSlug: string | null;
  notifId: string;
  startedAt: string;
  startTask?: number;
  endTask?: number;
}

// ─── Constants ────────────────────────────────────────────────────────────────

export const BULK_JOB_TTL_MS = 4 * 60 * 60 * 1000;
export const WATCHED_ANALYSIS_TTL_MS = 3 * 60 * 60 * 1000;

export const LS_KEY_BULK = 'kh_bg_executions';
export const LS_KEY_WATCHED = 'kh_bg_watched_analyses';
